import { Typography } from '@mui/material';
import { useLocation } from 'react-router-dom';
import { RouterLink } from 'common/ui/RouterLink';
import { Paths } from 'services/navigation/paths';
import { useDrawer } from 'services/drawer/hooks';

type Props = {
  campaignId?: string | null;
  jobTitle: string;
};

/**
 * The campaign a conversation belongs to, linked unless the reader is already
 * looking at that campaign's page — from there the link would go nowhere.
 *
 * Clicking closes the drawer: navigating with it still mounted would leave it
 * sitting on top of the page it just opened.
 */
export const CampaignTitleLink: React.FC<Props> = ({
  campaignId,
  jobTitle
}) => {
  const { pathname } = useLocation();
  const { forceCloseDrawer } = useDrawer();

  const campaignPath = campaignId
    ? `${Paths.OUTBOUND_CAMPAIGN}/${campaignId}`
    : null;
  const isAlreadyOnCampaign =
    !!campaignPath && pathname.startsWith(campaignPath);

  return (
    <Typography>
      For{' '}
      {campaignPath && !isAlreadyOnCampaign ? (
        <RouterLink to={campaignPath} onClick={forceCloseDrawer}>
          {jobTitle}
        </RouterLink>
      ) : (
        jobTitle
      )}
    </Typography>
  );
};
